import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Props = {
  extraClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Wrapper',
  props: {
    extraClass: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal modal-display", _ctx.extraClass]),
    "data-testid": "modal-info"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})